"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSCarePackageCharge_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSCarePackage_1 = require("./NHSCarePackage");
var NHSCarePackageCharge_Factory = /** @class */ (function () {
    function NHSCarePackageCharge_Factory() {
    }
    NHSCarePackageCharge_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CarePackageChargeId: model.CarePackageChargeId,
            CarePackageId: model.CarePackageId,
            EffectiveDateFrom: Date_Factory_1.Date_Factory.CreateIncoming(model.EffectiveDateFrom),
            LabFeesAllowed: model.LabFeesAllowed,
            NHSCarePackage: NHSCarePackage_1.NHSCarePackage_Factory.CreateIncoming(model.NHSCarePackage),
            PackageFee: model.PackageFee,
            PatientCharge: model.PatientCharge,
        };
        return result;
    };
    NHSCarePackageCharge_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CarePackageChargeId: model.CarePackageChargeId,
            CarePackageId: model.CarePackageId,
            EffectiveDateFrom: Date_Factory_1.Date_Factory.CreateOutgoing(model.EffectiveDateFrom),
            LabFeesAllowed: model.LabFeesAllowed,
            NHSCarePackage: NHSCarePackage_1.NHSCarePackage_Factory.CreateOutgoing(model.NHSCarePackage),
            PackageFee: model.PackageFee,
            PatientCharge: model.PatientCharge,
        };
        return result;
    };
    return NHSCarePackageCharge_Factory;
}());
exports.NHSCarePackageCharge_Factory = NHSCarePackageCharge_Factory;
